import { API_PATHS } from "../API_PATHS";
import { request } from "../utils";

export const getIssueVersions = (organizationId: number, tenantId: number) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.ISSUES_SUMMARY.GET_VERSIONS(organizationId, tenantId)}`,
  });
};

export const getListIssues = (
  syncLogId: string,
  orgId: number,
  tenantId: number,
  owners: string[],
  startDate: string,
  endDate: string,
) => {
  return request({
    method: "GET",
    // eslint-disable-next-line max-len
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.ISSUES_SUMMARY.GET_LIST_REPORT(syncLogId, orgId, tenantId, owners, startDate, endDate)}`,
  });
};

export const getIssuesHeader = (
  syncLogId: string,
  orgId: number,
  tenantId: number,
  owners?: string[],
  startDate?: string,
  endDate?: string,
) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.ISSUES_SUMMARY.GET_HEADER_INFO(
      syncLogId,
      orgId,
      tenantId,
      owners,
      startDate,
      endDate,
    )}`,
  });
};

export const getIssuesDoughnutChartData = (
  syncLogId: string,
  orgId: number,
  tenantId: number,
  owners?: string[],
  startDate?: string,
  endDate?: string,
) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.ISSUES_SUMMARY.GET_DOUGHNUT_CHART(
      syncLogId,
      orgId,
      tenantId,
      owners,
      startDate,
      endDate,
    )}`,
  });
};

export const getIssuesBarChartData = (
  syncLogId: string,
  orgId: number,
  tenantId: number,
  owners?: string[],
  startDate?: string,
  endDate?: string,
) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.ISSUES_SUMMARY.GET_BAR_CHART(
      syncLogId,
      orgId,
      tenantId,
      owners,
      startDate,
      endDate,
    )}`,
  });
};
